import classNames from "classnames";
import { CSSProperties } from "react";
import {
	GridContainerProps,
	ListItemProps,
	PageSectionProps,
} from "../../../../../constants/pageSectionTypes";
import MarkdownRenderer from "../../../../common/MarkdownRenderer/MarkdownRenderer";
import ContentList from "../../../../ui/ContentList/ContentList";
import ContentListItem from "../../../../ui/ContentListItem/ContentListItem";
import "./UrgencyData.scss";

export type UrgencyDataContent = {
	enabled: boolean;
	label: string;
	items: ListItemProps[];
	grid: GridContainerProps;
};

const UrgencyData = ({
	sectionContent,
	className,
}: PageSectionProps<UrgencyDataContent>) => {
	return (
		<section className={classNames("urgency-data keep-color", className)}>
			<ContentList
				className="content-list--grid"
				style={
					{
						"--grid-template-columns": sectionContent.grid.gridTemplateColumns,
						"--grid-template-rows": sectionContent.grid.gridTemplateRows,
					} as CSSProperties
				}>
				{sectionContent.items.map((item, index) => (
					<ContentListItem
						key={index}
						style={
							{
								"--item-background": item.background,
								"--grid-row": item.gridRow,
								"--grid-column": item.gridColumn,
							} as CSSProperties
						}
						className="content-list__item--with-background content-list__item--text">
						<MarkdownRenderer>{item.content}</MarkdownRenderer>
					</ContentListItem>
				))}
			</ContentList>
		</section>
	);
};

export default UrgencyData;
